export default "__VITE_ASSET__DjhuV88W__"